import { Injectable } from "@angular/core";
import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { VerificarSesionService } from "@services/verificar-sesion.service";
import { SessionCaducadaService } from "@services/session-caducada.service";
import { SessionService } from "@services/session.service";
import { environment } from "@env/environment";

/**
 * Interceptor para peticiones POST:
 *  - Loggea la petición.
 *  - Verifica asíncronamente contra el backend si la sesión sigue activa.
 *    Si no lo está, marca la sesión como caducada para que la UI bloquee la pantalla.
 *
 * Evita llamar a sí mismo y solo verifica cuando hay sesión en el cliente.
 */
@Injectable()
export class PostLoggerInterceptor implements HttpInterceptor {
	/** Evita disparar verificaciones en paralelo cuando llegan múltiples POST a la vez. */
	private verificacionEnVuelo = false;

	constructor(
		private verificarSesionService: VerificarSesionService,
		private sessionCaducadaService: SessionCaducadaService,
		private sessionService: SessionService
	) {}

	intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (req.method !== "POST") {
			return next.handle(req);
		}

		if (this.debeVerificar(req.url)) {
			this.verificacionEnVuelo = true;
			this.verificarSesionService.verificarSesion().subscribe({
				next: (activa) => {
					if (!activa) {
						this.sessionCaducadaService.marcarCaducada();
					}
				},
				error: () => {
					// Si la verificación falla, no bloqueamos la app (podría ser un problema transitorio).
				},
				complete: () => {
					this.verificacionEnVuelo = false;
				},
			});
		}

		return next.handle(req);
	}

	private debeVerificar(url: string): boolean {
		if (this.verificacionEnVuelo) return false;
		if (this.sessionCaducadaService.caducada) return false;
		if (!this.sessionService.isAuthenticated()) return false;
		// Evitamos recursión: no verificar sobre el mismo endpoint de verificación.
		if (url.endsWith(environment.verificarSesion)) return false;
		return true;
	}
}
